module.exports = __webpack_public_path__ + "media/src/application/media/fri-e48e1b48da977eff84c993188c12a086.png";